import React from 'react';
import { inject, observer } from 'mobx-react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import Controller from '../../components/Controller';

import { __ } from '../../i18n';

@graphql(gql`mutation deleteSurvey($deleteSurveyMutation: DeleteSurveyInput!) {
  deleteSurvey(input: $deleteSurveyMutation) {
    clientMutationId
  }
}`, {
  options: {
  refetchQueries: ['MessageSurveyResultsEntityQuery', 'MessageSurveyResultsOrganizationQuery', 'MessageNodeEntityQuery', 'MessageNodeOrganizationQuery']
  }
  })
@inject('store') @observer
export default class SurveyDelete extends Controller {
  request = () => this.props.mutate({
    variables: {
      deleteSurveyMutation: {
        id: this.props.survey.dbId
      }
    }
  }).then(() => {
    this.props.store.snackbar = { active: true, message: __('Survey was deleted'), success: true };
    this.props.store.appends.pop();
  })

  render() {
    return (
      <Controller
        id="SurveyDelete"
        delete
        object={__('survey')}
        onSubmit={this.onSubmit}
        onCancel={() => this.props.store.appends.pop()}
        {...this.props}
      />
    );
  }
}
